import { BifrostBackendNestApi } from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const tenantId = appConfig.tenantId;

const FavoriteRestaurantProvider = {
	addFavoriteRestaurant({ idpToken, shopId }) {
		return BifrostBackendNestApi.post("/favoriteRestaurant?tenantId=" + tenantId, {
			shopId,
			tenantId
		}, {
			headers: {
				Authorizationidp: idpToken
			}
		});
	},
	deleteFavoriteRestaurant({ idpToken, shopId }) {
		return BifrostBackendNestApi.delete("/favoriteRestaurant?tenantId=" + tenantId, {
			headers: {
				Authorizationidp: idpToken
			},
			data: {
				shopId,
				tenantId
			}
		});
	}
};

export default Object.freeze(FavoriteRestaurantProvider);
